// @ts-strict-ignore
import type { QueryHookOptions } from "@apollo/client";
/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
import { gql, useQuery } from "@apollo/client";

const WordpressFeaturedItems_Emerson_Query = gql`
  query WordpressFeaturedItems_Emerson_Query($type: String) {
    featuredItems(
      first: 25
      where: { featuredType: $type, orderby: { field: DISPLAYORDER_FEATURED, order: ASC } }
    ) {
      nodes {
        id
        featuredType
        featuredBrandId
        featuredBrandActionUrl
        featuredBrandLogo
        featuredBrandImage
        featuredBrandName
        featuredBrandText
        featuredDisplayOrder
        featuredProductId
        featuredBrandLocation
      }
    }
  }
`;

interface Variables {
  type: string;
}

export type WordpressFeaturedItemType = {
  id?: string;
  featuredType: string;
  featuredBrandId: string;
  featuredBrandActionUrl?: string;
  featuredBrandLogo?: string;
  featuredBrandImage?: string;
  featuredBrandName?: string;
  featuredBrandText?: string;
  featuredDisplayOrder: number;
  featuredProductId?: string;
  featuredBrandLocation?: string;
};

export type WordpressFeaturedItemsResults = {
  featuredItems?: {
    nodes?: WordpressFeaturedItemType[];
  };
};

const FeaturedBrandLocation = {
  home: "home",
  megamenu: "megamenu",
  brand: "brand",
};

const useWordpressFeaturedItemsQuery = (
  options?: QueryHookOptions<WordpressFeaturedItemsResults, Variables>
) =>
  useQuery<WordpressFeaturedItemsResults>(WordpressFeaturedItems_Emerson_Query, {
    context: { clientName: "wordpress" },
    ...options,
  });

export {
  useWordpressFeaturedItemsQuery,
  WordpressFeaturedItems_Emerson_Query,
  FeaturedBrandLocation,
};
